import { render, staticRenderFns } from "./UnionFieldEdit.vue?vue&type=template&id=07a05e18&scoped=true"
import script from "./UnionFieldEdit.vue?vue&type=script&lang=js"
export * from "./UnionFieldEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a05e18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a05e18')) {
      api.createRecord('07a05e18', component.options)
    } else {
      api.reload('07a05e18', component.options)
    }
    module.hot.accept("./UnionFieldEdit.vue?vue&type=template&id=07a05e18&scoped=true", function () {
      api.rerender('07a05e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/add/union/UnionFieldEdit.vue"
export default component.exports